import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Flex, Text } from '@mantine/core';
import { PdfViewerModal } from '@dealstack/frontend/shared/components/DocumentViewerV2/PdfViewer/PdfViewerModal';
import { useDownloadedFileBlob } from '@dealstack/frontend/shared/modules/document/file/hooks/useDownloadedFileBlob';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';
import { FormPair } from '@dealstack/frontend/investor/pages/Investment/common/InvestorKycFormsTable/types';

interface Props {
	className?: string;
	opened: boolean;
	onClose: () => void;
	form: FormPair;
}

export const PreviewKycFormModal = ({ opened, onClose, form, className }: Props) => {
	const tInvestor = useTranslationInvestor();
	const { dealId } = useRequiredParams('dealId');
	const fileId = form.fileId ?? form.templateFileId;
	const { data: file, isLoading } = useDownloadedFileBlob({ fileId, dealId });
	const kycFormName = form.name;
	const instruction = form.instruction;
	const rejectionComment = form.rejectionComment ?? undefined;

	const showDetails = !!instruction || !!rejectionComment;

	const formDetails = (
		<Flex direction="column" gap="1rem">
			{!!instruction && (
				<Flex className={className} direction="column" gap="0.5rem">
					<Text size="B6Medium" c="gray.9">
						{tInvestor(`investment.join.contracts.instructions`)}
					</Text>
					<Text variant="p-md">{instruction}</Text>
				</Flex>
			)}
			{!!rejectionComment && (
				<Flex className={className} direction="column" gap="0.5rem">
					<Text size="B6Medium" c="red.6">
						{tInvestor('investment.join.kyc.proof_box.rejected')}
					</Text>
					<Text variant="p-md">
						{tInvestor('investment.join.kyc.proof_box.rejected_comment', {
							rejectionComment,
						})}
					</Text>
				</Flex>
			)}
		</Flex>
	);

	return (
		<PdfViewerModal
			className={className}
			opened={opened}
			onClose={onClose}
			pdfViewerProps={{
				file: file?.blob,
				fileName: kycFormName,
				details: showDetails ? formDetails : null,
				isLoading,
				showDetailsByDefault: true,
			}}
		/>
	);
};
